<div fxLayout="row" fxLayoutAlign="space-evenly center" class="container">
  <button mat-button color="primary" (click)="gotIt()">Got It</button>
  <button mat-button color="primary" (click)="isDeclined()">Declined</button>
  <button mat-button color="primary" (click)="isSold()">Sold</button>
</div>
